import { React, Heading, Text, Popover } from "@cisco/spaces-dash-lib-styleguide";
import { v4 as uuidv4 } from "uuid";

export const permissionFormatter = (data, title) => {
  if (data.getValue() !== undefined) {
    const { length } = data.renderValue();
    if (data.renderValue().length > 3) {
      return (
        <>
          <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
            {data
              .renderValue()
              .slice(0, 3)
              .map((ele, index) => {
                if (index == 2) return <li key={uuidv4()}>{ele}</li>;
                return <li key={uuidv4()}>{ele},</li>;
                // console.log(ele,index);
              })}
          </ul>
          <Popover
            title={
              <ul style={{ listStyleType: "none", padding: 10, margin: 0 }}>
                <Heading size="xs">{title}</Heading>
                {data.renderValue().map((ele, index) =>
                  index == length - 1 ? (
                    <li key={uuidv4()}>
                      <Text size="p3">{ele}</Text>
                    </li>
                  ) : (
                    <li key={uuidv4()}>
                      <Text size="p3">{ele},</Text>
                    </li>
                  )
                )}
              </ul>
            }
            placement="bottom"
            size="lg"
          >
            <Text color="#0d5cbd" size="p3" className="hover-target" style={{ cursor: "pointer", width: "fit-content" }}>
              +{length - 3} more
            </Text>
          </Popover>
        </>
      );
    }
    return (
      <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
        {data.renderValue().map((ele, index) =>
          index == length - 1 ? (
            <li key={uuidv4()}>
              <Text size="p3">{ele}</Text>
            </li>
          ) : (
            <li key={uuidv4()}>
              <Text size="p3">{ele},</Text>
            </li>
          )
        )}
      </ul>
    );
  }
  return data.renderValue();
};
